import React from "react";

const Promise = () => (
  <section className="promise" aria-labelledby="promise-title">
    <div className="container">
      <div className="head">
        <h2 className="section-title" id="promise-title">
          What makes this{" "}
          <span className="nobr">
            course <em className="hl">different</em>.
          </span>
        </h2>
      </div>
      <div className="promise-strip">
        <div className="promise-item">
          <span className="num" aria-hidden="true">
            01
          </span>
          <div>
            <p className="t">A CPD-accredited Mini MBA.</p>
            <p className="s">
              Real credit for real learning. Signed, dated, trackable.
            </p>
          </div>
        </div>
        <div className="promise-item">
          <span className="num" aria-hidden="true">
            02
          </span>
          <div>
            <p className="t">Marked by humans, not bots.</p>
            <p className="s">
              A real person reads your work and writes back, usually within 24
              hours.
            </p>
          </div>
        </div>
        <div className="promise-item">
          <span className="num" aria-hidden="true">
            03
          </span>
          <div>
            <p className="t">Personalised to your goals.</p>
            <p className="s">
              Our AI rewrites every lesson around your role and goals.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Promise;
